import { Button, Stack } from "@mui/joy";
import { theme } from "styles/theme";

export default function TabButtonList({
  selectedTab,
  data,
}: {
  selectedTab?: string;
  data: { id: string; label: string; onClick: () => void }[];
}) {
  return (
    <Stack
      direction="row"
      spacing="4px"
      sx={{
        width: "100%",
        height: "42px",
        backgroundColor: theme.vars.palette.Surface.Backward,
        borderRadius: "12px",
        alignItems: "center",
        p: 0.5,
      }}
    >
      {data.map(({ id, label, onClick }, index) => (
        <Stack
          key={index}
          sx={{
            flex: 1,
          }}
        >
          <Button
            variant={"Tab"}
            size="xs"
            color={id === selectedTab ? "primary" : "secondary"}
            sx={{
              height: "34px",
              ...(id === selectedTab && {
                borderRadius: "8px",
              }),
              fontWeight: 700,
            }}
            onClick={onClick}
          >
            {label}
          </Button>
        </Stack>
      ))}
    </Stack>
  );
}